module.exports = __webpack_public_path__ + "static/img/img-fj-yly.9eaa8b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img-fj-yly.png
// module id = rOo1
// module chunks = 222